<template>
  <el-dialog
    ref="dialog"
    :visible.sync="viewDialog"
    :close-on-click-modal="false"
    :before-close="beforeClose"
  >
    <el-form
      v-loading="isLoading"
      ref="partForm"
      :rules="rules"
      :model="formModel"
    >
      <el-row :gutter="15">
        <el-col :sm="12">
          <el-form-item label="Part" prop="part_no">
            <el-select
              id="part_no"
              v-model="formModel.part_no"
              filterable
              @change="getPartInfo"
            >
              <el-option
                v-for="part in parts"
                :key="part.id"
                :value="part.part_no"
                :label="part.part_no"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :sm="12">
          <el-form-item label="Part Description">
            <el-input
              :readonly="true"
              v-model="formModel.part_description"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="Remarks" prop="description">
        <el-input type="textarea" v-model="formModel.description"> </el-input>
      </el-form-item>
      <el-form-item label="Quantity" prop="quantity">
        <el-input-number
          v-model.number="formModel.quantity"
          :controls="false"
        ></el-input-number>
      </el-form-item>
    </el-form>
    <div class="text-right">
      <el-button @click="save" type="primary">Save </el-button>
      <el-button @click="close">Cancel</el-button>
    </div>
  </el-dialog>
</template>

<script>
import Part from "@/models/Part";
import ULD from "@/models/ULD";
import socket from "@/socket";
export default {
  name: "requestSpareParts",

  data() {
    return {
      viewDialog: false,
      isLoading: false,
      formModel: {},
      parts: [],
      // approved_requests: [],
      rules: {
        parts_id: [{ required: true, message: "Part is required." }],
        quantity: [
          { required: true, message: "Quantity is required." },
          {
            validator: (rule, value, callback) => {
              if (value <= 0) {
                return callback(new Error("Quantity is required."));
              }
              callback();
            },
            trigger: "blur"
          }
        ],
        part_no: [
          { required: true, message: "Part is required." },
          {
            validator: (rule, value, callback) => {
              var part = this.parts.find(o => {
                return o.part_no == value;
              });
              if (!part) {
                return callback(new Error("Part information not found."));
              }

              if (
                "_default" in this.formModel &&
                this.formModel._default == value
              )
                callback();

              this.formModel.part_id = part.id;
              part = this.spareParts.data.find(o => {
                return o.requested_parts.part_no == value;
              });
              if (part) {
                return callback(new Error("This part is already added."));
              }

              part = this.approvedRequests.find(o => {
                return o.part_no == value;
              });
              if (part) {
                return callback(
                  new Error("This part is already on the approved requests.")
                );
              }

              callback();
            },
            trigger: "change"
          }
        ]
      }
    };
  },
  computed: {
    user() {
      return this.$store.getters["auth/user"];
    },
    uld() {
      return this.$store.getters["uld/info"];
    },
    spareParts() {
      return this.$store.getters["uld/spareParts"];
    },
    approvedRequests() {
      return this.$store.getters["uld/stockoutItems"];
    }
  },
  methods: {
    open(request) {
      if (request) {
        this.formModel = {
          _default: request.requested_parts.part_no,
          id: request.id,
          description: request.description,
          quantity: request.quantity,
          parts_id: request.requested_parts.id,
          part_no: request.requested_parts.part_no,
          part_description: request.requested_parts.description
        };
      } else {
        this.formModel = {
          description: "",
          part_id: "",
          part_description: "",
          part_no: "",
          quantity: ""
        };
      }
      this.viewDialog = true;
    },
    close() {
      this.viewDialog = false;
    },
    beforeClose(done) {
      if (this.isLoading) return false;
      return done();
    },
    getPartInfo() {
      var part = this.parts.find(o => {
        return o.part_no == this.formModel.part_no;
      });
      if (part) {
        this.formModel.part_description = part.description;
        this.formModel.parts_id = part.id;
      }
    },
    save() {
      this.$confirm("Do you want to submit this request?")
        .then(() => {
          this.$refs.partForm.validate(valid => {
            if (!valid) return false;

            let payload = {
              uld_id: this.uld.id,
              description: this.formModel.description,
              mechanic_id: this.user.id,
              quantity: this.formModel.quantity,
              parts_id: this.formModel.parts_id
            };
            this.isLoading = true;
            if (this.formModel.id) {
              payload.id = this.formModel.id;
              ULD.update_requested_part(payload).then(resp => {
                this.isLoading = false;
                if (resp.code == 200) {
                  this.$notify({
                    type: "success",
                    message: "Request updated successfully.",
                    position: "bottom-right"
                  });
                  this.$store.dispatch("uld/fetchSpareParts", this.uld.id);
                  this.close();
                }
              });
            } else {
              ULD.request_part(payload).then(resp => {
                this.isLoading = false;
                if (resp.code == 200) {
                  this.$notify({
                    type: "success",
                    message: "Request saved successfully.",
                    position: "bottom-right"
                  });
                  this.$store.dispatch("uld/fetchSpareParts", this.uld.id);
                  this.close();
                  socket.emit("send_notification", {
                    sendto: "supervisor",
                    channel: `room-channel.${resp.notification.notify_to_id}`,
                    data: resp.notification
                  });
                }
              });
            }
          });
        })
        .catch(() => {});
    }
  },
  mounted() {
    Part.getGlossary().then(list => {
      this.parts = list;
    });
  }
};
</script>

<style lang="css" scoped></style>
